"use client";

import { useEffect, useState } from "react";
import { resolveVideo } from "../video/default-resolver";
import { VideoPlayer } from "../video/player";
import "../video/video.css";

export function DrillVideo({ url, title }: { url: string; title: string }) {
  const [hostname, setHostname] = useState<string>();
  useEffect(() => setHostname(window.location.hostname), []);
  return (
    <VideoPlayer
      url={url}
      title={`${title}の参考動画`}
      resolve={resolveVideo}
      context={{ hostname }}
    />
  );
}
